import React from 'react';
import PbssFilesAddContainer from '../../../Containers/AdminContainer/PbssFiles/PbssFilesAddContainer';

const PbssFilesAddScreen = () => {
  return <PbssFilesAddContainer />;
};

export default PbssFilesAddScreen;
